import * as types from './types'

const getCapaianKinerjaGubernur_act = (tahun = "") => async (dispatch, getState, Api) => {
    dispatch({
        type: types.GET_CPK_GUBERNUR_START
    })
    const response = tahun > 2025 ? await Api.getCapaianPKGubernurSakinah(tahun) : await Api.getCapaianPKGubernur(tahun)
    if (response.status !== "failed") {
        dispatch({
            type: types.GET_CPK_GUBERNUR_SUCCESS,
            payload: {
                data: tahun > 2025 ? response.data.data : response.data.message,
                message: response.data.label
            }
        })
    } else {
        dispatch({
            type: types.GET_CPK_GUBERNUR_FAILED,
            payload: {
                message: response.error
            }
        })
    }
}

export {
    getCapaianKinerjaGubernur_act
}

